import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMenuSucceed, EGetMenuActionType } from './types';
import { IMenuBlockItemsSchema } from '../../../repositories/journal/entities/menu/MenuBlockItemsSchema';

export const getMenuSucceed: (items: IMenuBlockItemsSchema[]) => TGetMenuSucceed = actionGenerator<
  EGetMenuActionType.Succeed,
  IMenuBlockItemsSchema[]
>(EGetMenuActionType.Succeed);
